import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchPolicies, setPolicyActive, createPolicy, updatePolicy } from '../../services/api/policiesService';

export const loadPolicies = createAsyncThunk('policies/load', async () => fetchPolicies());
export const addPolicy = createAsyncThunk('policies/add', async (payload, { rejectWithValue }) => {
  try { return await createPolicy(payload); }
  catch (err) { return rejectWithValue(err?.response?.data?.message || err?.response?.data?.detail || 'Policy could not be created.'); }
});
export const editPolicy = createAsyncThunk('policies/edit', async ({ id, changes }, { rejectWithValue }) => {
  try { return await updatePolicy(id, changes); }
  catch (err) { return rejectWithValue(err?.response?.data?.message || err?.response?.data?.detail || 'Policy could not be updated.'); }
});

export const togglePolicy = createAsyncThunk(
  'policies/toggle',
  async ({ id, active }, { rejectWithValue }) => {
    try { return await setPolicyActive(id, active); }
    catch (err) { return rejectWithValue(err?.response?.data?.message || err?.response?.data?.detail || 'Policy could not be changed.'); }
  }
);

const policiesSlice = createSlice({
  name: 'policies',
  initialState: { status: 'idle', mutationStatus: 'idle', error: null, items: [] },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadPolicies.pending, (state) => { state.status = 'loading'; })
      .addCase(loadPolicies.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.items = action.payload;
      })
      .addCase(loadPolicies.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      .addMatcher(
        (action) => [addPolicy.pending.type, editPolicy.pending.type, togglePolicy.pending.type].includes(action.type),
        (state) => { state.mutationStatus = 'loading'; state.error = null; }
      )
      .addCase(addPolicy.fulfilled, (state, action) => { state.mutationStatus = 'succeeded'; state.items.unshift(action.payload); })
      .addCase(editPolicy.fulfilled, (state, action) => { state.mutationStatus = 'succeeded'; const item = state.items.find((p) => p.id === action.payload.id); if (item) Object.assign(item, action.payload); })
      .addCase(togglePolicy.fulfilled, (state, action) => {
        state.mutationStatus = 'succeeded';
        const item = state.items.find((p) => p.id === action.payload.id);
        if (item) item.active = action.payload.active;
      })
      .addMatcher(
        (action) => [addPolicy.rejected.type, editPolicy.rejected.type, togglePolicy.rejected.type].includes(action.type),
        (state, action) => { state.mutationStatus = 'failed'; state.error = action.payload || action.error.message || 'Policy change failed.'; }
      );
  }
});

export default policiesSlice.reducer;
